import PageTitle from '../components/PageTitle';

import { InlineClippedImage } from '../components/InlineClippedImage';

import PROG2024ARCover from '../assets/images/PROG-2024-AR-Cover.jpg';
import PROG2024AnnualLetterCover from '../assets/images/PROG-2024-Annual-Letter-Cover.jpg';
import PROG2024ARtoShareholdersCover from '../assets/images/PROG-2024-AR-to-Shareholders-Cover.jpg';
import PROG2025FirstQtrCover from '../assets/images/PROG-2025-First-Qtr-Cover.jpg';
import PROG2025SecondQtrCover from '../assets/images/PROG-2025-Second-Qtr-Cover.jpg';
import PROG2025ThirdQtrCover from '../assets/images/PROG-2025-Third-Qtr-Cover.jpg';

import Connell_2010_Umbrella from '../assets/images/content/Connell_2010_Umbrella.jpg';

function renderDownloadableFiles(items) {
	return items.map((item, index) => (
		<div key={index} className="">
			<div>
				<img src={item.thumbnail} alt={item.title} className="mb-6" />
				<p className="font-trade-compressed uppercase m-0 text-[#F05860] text-[1.875rem] font-bold tracking-widest">{item.title}</p>
			</div>
			<div>
				<div className="flex flex-col gap-4 mt-6">
					{item.files.map((file, fileIndex) => (
						<div className="flex flex-col gap-0" key={fileIndex}>
							<p className="uppercase text-[0.875rem] font-[400] leading-[100%] tracking-[0.04375rem] mb-0">{file.name}</p>
							<a href={file.url} target="_blank" rel="noreferrer" className="underline text-[0.75rem]">
								{file.desc}
							</a>
						</div>
					))}
				</div>
			</div>
		</div>
	));
}

const DownloadableFiles = [
	{
		title: '2024 Summary Annual Report',
		thumbnail: PROG2024ARCover,
		files: [
			{
				name: 'Viewable Color PDF',
				desc: 'Download Color PDF',
				url: './pdfs/Progressive-2024-AR.pdf',
			},
			{
				name: 'Printable PDF (No Artwork)',
				desc: 'Download Black and White PDF',
				url: './pdfs/Progressive-2024-AR-BW.pdf',
			},
		],
	},
	{
		title: 'Complete 2024 Annual Report to Shareholders',
		thumbnail: PROG2024ARtoShareholdersCover,
		files: [
			{
				name: 'Printable PDF',
				desc: 'Download Printable PDF',
				url: './pdfs/Progressive-2024-Financial-Review.pdf',
			},
		],
	},
	{
		title: 'Annual Letter to Shareholders',
		thumbnail: PROG2024AnnualLetterCover,
		files: [
			{
				name: 'Viewable Color PDF',
				desc: 'Download Color PDF',
				url: './pdfs/Progressive-2024-AR-Letter.pdf',
			},
			{
				name: 'Printable PDF (No Artwork)',
				desc: 'Download Black and White PDF',
				url: './pdfs/Progressive-2024-AR-LetterBW.pdf',
			},
		],
	},
];

const QuarterlyFiles = [
	{
		title: '2025 Third Quarter Report',
		thumbnail: PROG2025ThirdQtrCover,
		files: [
			{
				name: 'Viewable Color PDF',
				desc: 'Download Color PDF',
				url: './pdfs/Progressive-2025-Third-Quarter.pdf',
			},
		],
	},
	{
		title: '2025 Second Quarter Report',
		thumbnail: PROG2025SecondQtrCover,
		files: [
			{
				name: 'Viewable Color PDF',
				desc: 'Download Color PDF',
				url: './pdfs/Progressive-2025-Second-Quarter.pdf',
			},
		],
	},
	{
		title: '2025 First Quarter Report',
		thumbnail: PROG2025FirstQtrCover,
		files: [
			{
				name: 'Viewable Color PDF',
				desc: 'Download Color PDF',
				url: './pdfs/Progressive-2025-First-Quarter.pdf',
			},
		],
	},
];

const Downloads = () => {
	return (
		<>
			<PageTitle title="Downloads" />
			<div className="container py-24 max-w-container-lg">
				<div className="grid gap-6 mb-24 md:grid-cols-3">{renderDownloadableFiles(QuarterlyFiles)}</div>
				<div className="grid gap-6 md:grid-cols-3">{renderDownloadableFiles(DownloadableFiles)}</div>
			</div>
			<div className="container py-24">
				<div className="max-w-[1114px]">
					<InlineClippedImage
						src={Connell_2010_Umbrella}
						alt="Art"
						dimensions={{
							width: 1920,
							height: 1440,
						}}
						className="max-w-[452px] w-full m-0 ml-auto"
						clipPaths={[
							{
								initial: { x: '34%', y: '32%', width: '40%' },
								expanded: { x: '0%', y: '0%', width: '100%' },
							},
						]}
					/>
				</div>
			</div>
		</>
	);
};

export default Downloads;
